import React, { Dispatch, SetStateAction } from 'react';
import { ChangeEmail } from './ChangeEmail';
import { Success } from './Success';
import { Warning } from './Warning';

export const ChangeEmailSteps = ({
  step,
  setStep
}: {
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
}) => {
  const steps = (step: number) => {
    switch (step) {
      case 1:
        return <Warning setStep={setStep} />;
      case 2:
        return <ChangeEmail setStep={setStep} />;
      case 3:
        return <Success />;

      default:
        return <div></div>;
    }
  };
  return <>{steps(step)}</>;
};
